/**
 * Every worker-app route. Here so `workerFullUrls`, which app-admin uses and
 * which can't import app-worker, is built from these paths. The worker's url
 * builders and params stay in `app-worker/urls/`.
 */
export const WorkerPages = {
  Root: '/',
  Home: '/home',
  Visits: '/visits',
  SnowAddresses: '/snow-addresses',
  CompletedVisits: '/completed-visits',
  Payments: '/payments',
  SnowPay: '/snow-pay',
  LandPay: '/land-pay',
  Availability: '/availability',
  Login: '/login',
  SignUpPhone: '/signup/phone',
  SignUpPersonalInfo: '/signup/personal-info',
  SignUpVisitTypes: '/signup/visit-types',
  SignUpPreferences: '/signup/preferences',
  SignUpTermsAndConditions: '/signup/terms-conditions',
  Profile: '/profile',
  ProfileVisitTypes: '/profile/visit-types',
  ProfilePreferences: '/profile/preferences',
  ProfileTermsAndConditions: '/profile/terms-conditions',
  Settings: '/settings',
  visitPage: (visitId: string) => `/visit/${visitId}`,
  DocsStart: '/docs/start',
  DocsFaq: '/docs/faq',
  DocsTutorials: '/docs/tutorials',
};
